import { defineMessages } from 'react-intl'

export default defineMessages({
  timingLevel: {
    id: 'containers.SupplierProfile.components.Rates.timingLevel',
    defaultMessage: 'Timing Level',
  },
  timingLevelHint1: {
    id: 'containers.SupplierProfile.components.Rates.timingLevelHint.1',
    defaultMessage: 'Recording matching the total time duration of the manuscript length. Additional percentage added to core fee. Example core fee is 100 EUR added 30% = 130 EUR.',
  },
  timingLevelHint2: {
    id: 'containers.SupplierProfile.components.Rates.timingLevelHint.2',
    defaultMessage: 'Timing on paragraph level according to time codes in the script. Additional percentage added to core fee. Example core fee is 100 EUR added 30% = 130 EUR.',
  },
  media: {
    id: 'containers.SupplierProfile.components.Rates.media',
    defaultMessage: 'Media',
  },
  paidAdvertising: {
    id: 'containers.SupplierProfile.components.Rates.paidAdvertising',
    defaultMessage: 'Paid Advertising',
  },
  ownedMedia: {
    id: 'containers.SupplierProfile.components.Rates.ownedMedia',
    defaultMessage: 'Owned Media',
  },
  loading: {
    id: 'containers.SupplierProfile.components.Rates.loading',
    defaultMessage: 'Loading',
  },
  save: {
    id: 'containers.SupplierProfile.components.Rates.save',
    defaultMessage: 'Save rates',
  },
  accept: {
    id: 'containers.SupplierProfile.components.Rates.accept',
    defaultMessage: 'Accept rates',
  },
  acceptedStandard: {
    id: 'containers.SupplierProfile.components.Rates.acceptedStandard',
    defaultMessage: 'Accepted',
  },
  acceptedCustom: {
    id: 'containers.SupplierProfile.components.Rates.acceptedCustom',
    defaultMessage: 'Filled in',
  },
  required: {
    id: 'containers.SupplierProfile.components.Rates.required',
    defaultMessage: 'Required',
  },
  saved: {
    id: 'containers.SupplierProfile.components.Rates.saved',
    defaultMessage: 'Saved',
  },
})
